// client/src/pages/secure/TrainingPage.js — the training portal.
//
// Everyone: My training (assignments, Training of the week, sessions), 90-day programme (own
// enrolment, Ask my mentor; a mentor's mentees), My CE (licences and
// external CE with certificates), Library (approved courses).
// Managing broker + office manager also: Programme overview (onboarding, mentors, this week's
// meeting, this month's module, programme editor), Requirements (rules with citations and history),
// Schedule & sessions (the automated weekly schedule, live sessions, attendance),
// CE overview (every licence's standing), People & reports (completion, overdue, CSV,
// printable records, training profiles).
import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { getCurrentUser } from '../../hooks/useCurrentUser';
import PageHeader from '../../components/shared/PageHeader';
import MyTraining from '../../components/secure/training/MyTraining';
import CeTracker from '../../components/secure/training/CeTracker';
import Library from '../../components/secure/training/Library';
import Requirements from '../../components/secure/training/Requirements';
import Schedule from '../../components/secure/training/Schedule';
import Reports, { CeOverview } from '../../components/secure/training/Reports';
import { ProgramAdmin, ProgramTab } from '../../components/secure/training/Program';

const TrainingPage = () => {
    const user = getCurrentUser();
    const isMB = !!user?.isManagingBroker && user?.role !== 'examiner';
    const isSupervisor = isMB || (user?.staffRole === 'Office Manager' && user?.role !== 'examiner');
    const linked = !!(user?.agentId || user?.employeeId);
    const tabs = [
        ['mine', 'My training'],
        ...(linked ? [['program', '90-day programme']] : []),
        ...(linked ? [['ce', 'My CE']] : []),
        ['library', 'Library'],
        ...(isSupervisor ? [['program-admin', 'Programme overview'], ['requirements', 'Requirements'], ['schedule', 'Schedule & sessions'], ['ce-overview', 'CE overview'], ['reports', 'People & reports']] : []),
    ];
    const [params, setParams] = useSearchParams();
    const tab = tabs.some(([k]) => k === params.get('tab')) ? params.get('tab') : 'mine';
    const go = (k) => setParams(k === 'mine' ? {} : { tab: k });

    return (
        <div>
            <PageHeader title="Training" description="In-house training for agents and office personnel, and each licensee's continuing-education tracker." />
            <div className="flex flex-wrap gap-1 border-b mb-5">
                {tabs.map(([k, label]) => (
                    <button key={k} type="button" onClick={() => go(k)}
                        className={`px-3 py-2 text-sm -mb-px border-b-2 ${tab === k ? 'border-slate-700 text-indigo-700 font-semibold' : 'border-transparent text-slate-600 hover:text-slate-900'}`}>
                        {label}
                    </button>
                ))}
            </div>
            {tab === 'mine' && <MyTraining onOpenLibrary={() => go('library')} />}
            {tab === 'program' && <ProgramTab />}
            {tab === 'program-admin' && <ProgramAdmin onGoSchedule={() => go('schedule')} />}
            {tab === 'ce' && <CeTracker canVerify={isSupervisor} />}
            {tab === 'library' && <Library isSupervisor={isSupervisor} />}
            {tab === 'requirements' && <Requirements />}
            {tab === 'schedule' && <Schedule />}
            {tab === 'ce-overview' && <CeOverview />}
            {tab === 'reports' && <Reports isMB={isMB} />}
        </div>
    );
};

export default TrainingPage;
